import {
  ArrowDownTrayIcon,
  ChartBarIcon,
  ShareIcon,
} from "@heroicons/react/20/solid";

const features = [
  {
    name: "Intuitive Lead Evaluation",
    description:
      "InProfiler automatically categorizes your LinkedIn connection requests based on your professional objectives. No more manual sorting.",
    href: "#",
    icon: ChartBarIcon,
    comingSoon: false,
  },
  {
    name: "Collaborative Lead Sharing",
    description:
      "Promote teamwork with InProfiler's lead sharing feature. Share potential leads with team members in just a click.",
    href: "#",
    icon: ShareIcon,
    comingSoon: false,
  },
  {
    name: "Affinity CRM Integration",
    description:
      "Synchronize InProfiler with your Affinity account for effortless transfer and management of high-value leads.",
    href: "#",
    icon: ArrowDownTrayIcon,
    comingSoon: false,
  },
];

export default function Features() {
  return (
    <div className="bg-white py-24 sm:py-32" id="features">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto lg:mx-0 lg:text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Smart Features Designed for Effective Networking
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            InProfiler utilizes innovative technology to help you sort,
            prioritize, and connect with your LinkedIn leads. Here's how:
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col">
                <dt className="text-base font-semibold leading-7 text-gray-900">
                  <div className="mb-6 flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-600">
                    <feature.icon
                      className="h-6 w-6 text-white"
                      aria-hidden="true"
                    />
                  </div>

                  <div>
                    <span>{feature.name}</span>
                    {feature.comingSoon && (
                      <span className="ml-3 inline-flex items-center gap-x-1.5 rounded-lg px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
                        Coming soon
                      </span>
                    )}
                  </div>
                </dt>
                <dd className="mt-1 flex flex-auto flex-col text-base leading-7 text-gray-600">
                  <p className="flex-auto">{feature.description}</p>
                  {/* <p className="mt-6">
                    <a
                      href={feature.href}
                      className="text-sm font-semibold leading-6 text-indigo-600"
                    >
                      Learn more <span aria-hidden="true">→</span>
                    </a>
                  </p> */}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
